<template>
  <a :href="item.link">
    <div class="media-card">
      <SanityImage
        :asset-id="assetId"
        auto="format"
        class="media-card__logo"
        fit="crop"
      />
    </div>
  </a>
</template>

<script setup>
import { computed } from '#imports';

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
});
const assetId = computed(() => props.item.logo.asset._ref);
</script>

<style lang="postcss" scoped>
.media-card {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  height: 100%;
  transition: var(--default-transition) background-color;
  border-radius: 16px;
  background-color: rgba(var(--white-color--rgb), 0.7);
  box-shadow: 0 0 0 1px rgba(17, 17, 17, 10%);

  @media (--tablet-vp) {
    max-width: none;
  }

  &:hover {
    background-color: rgba(var(--white-color--rgb), 1);
  }

  img {
    display: block;
    width: 100%;
    max-width: 210px;
  }

  @media (--x-small-vp) {
    img {
      width: auto;
    }
  }
}
</style>
